import { ActionTypes } from "../constants/action-types";

const initialState = {
    filtPovrchy: [],
    filtDoplnky: [],
    filtVybaveni: [],
    visibility: 'NORMAL'
}
export const filteringReducer = (state = initialState, {type, payload}) => {
    switch (type) {
        //do be deprecated
        //case ActionTypes.SET_FILTERING:
        //    return { ...state, filtering: payload};
        case ActionTypes.SET_FILTERING_POVRCHY:
            return { ...state, filtPovrchy: payload};
        case ActionTypes.SET_FILTERING_DOPLNKY:
            return { ...state, filtDoplnky: payload};
        case ActionTypes.SET_FILTERING_VYBAVENI:
            return { ...state, filtVybaveni: payload};        
        //depr    
        //case ActionTypes.CHANGE_FILTERING:
        //    let _filtering_toChange = Object.assign({},state.filtering);
        //    _filtering_toChange[payload.rodina]= !(payload.doporuceni);
        //    return { ...state, filtering: _filtering_toChange};  
        case ActionTypes.CHANGE_FILTERING_POVRCHY:
            let _filteringPovrchy_toChange = Object.assign({},state.filtPovrchy);
            _filteringPovrchy_toChange[payload.rodina]= !(payload.doporuceni);
            return { ...state, filtPovrchy: _filteringPovrchy_toChange}; 
        case ActionTypes.CHANGE_FILTERING_DOPLNKY:
            let _filteringDoplnky_toChange = Object.assign({},state.filtDoplnky);
            _filteringDoplnky_toChange[payload.rodina]= !(payload.doporuceni);
            return { ...state, filtDoplnky: _filteringDoplnky_toChange}; 
        case ActionTypes.CHANGE_FILTERING_VYBAVENI:
            let _filteringVybaveni_toChange = Object.assign({},state.filtVybaveni);
            _filteringVybaveni_toChange[payload.rodina]= !(payload.doporuceni);
            return { ...state, filtVybaveni: _filteringVybaveni_toChange}; 
        //Administratorskej visibility
        case ActionTypes.CHANGE_FILTERING_VISIBILITY:
            return { ...state, visibility: payload};             
        default:
            return state
    }
}